import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import { trackConversionStep } from '@/lib/analytics';

interface CTASectionProps {
  className?: string;
}

const CTASection = ({ className = '' }: CTASectionProps) => {
  const handleGetStartedClick = () => {
    // Track conversion pathway for LinkedIn profile visit
    trackConversionStep('about_page_get_started_click', 1);
  };

  return (
    <section className={`bg-gradient-to-br from-primary via-primary/95 to-secondary py-16 md:py-24 ${className}`}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="font-heading font-bold text-3xl md:text-4xl text-primary-foreground mb-6">
          Ready to Start Your Sustainability Journey?
        </h2>
        <p className="text-lg md:text-xl text-primary-foreground/90 mb-8 max-w-2xl mx-auto">
          Connect with Dr. Nupur to explore how GenCarbon can help your organization achieve its environmental and ESG goals.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="mailto:dr.nupur@gencarbon.in?subject=Consultation Request&body=Hello Dr. Nupur,%0D%0A%0D%0AI would like to schedule a consultation to discuss:"
            className="inline-flex items-center justify-center space-x-2 px-8 py-4 bg-conversion text-conversion-foreground font-heading font-semibold text-lg rounded-lg hover:bg-conversion/90 shadow-natural-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
          >
            <Icon name="EnvelopeIcon" size={24} />
            <span>Email Dr. Nupur</span>
          </a>
          
          <Link
            href="/get-started"
            className="inline-flex items-center justify-center space-x-2 px-8 py-4 bg-primary-foreground text-primary font-heading font-semibold text-lg rounded-lg hover:bg-primary-foreground/90 shadow-natural-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
          >
            <Icon name="RocketLaunchIcon" size={24} />
            <span>Get Started</span>
          </Link>
        </div>
        
        <div className="mt-12 pt-8 border-t border-primary-foreground/20">
          <p className="text-sm text-primary-foreground/80 mb-4">
            Prefer to chat? Connect with us on WhatsApp
          </p>
          <a
            href="https://wa.me/919876543210?text=Hello%20Dr.%20Nupur,%20I%20would%20like%20to%20learn%20more%20about%20GenCarbon's%20services"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center space-x-2 text-primary-foreground hover:text-accent transition-colors duration-200"
          >
            <Icon name="ChatBubbleLeftRightIcon" size={20} />
            <span className="font-medium">Start WhatsApp Conversation</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTASection;